/*
  LS location strip (sections/ls-location-banner.liquid).

  When it shows - only on a mismatch, never redirecting by itself:
  - the country Shopify detects for the visitor
    (browsing_context_suggestions.json) is one we sell to and pays in another
    currency than the shop being shown, or
  - the browser's main language is one of our languages and differs from the
    page language.
  The strip is one sentence with the pickers inline ("Looks like you're in
  Sweden. Show prices for [Sweden (SEK)] in [English]"), pre-set to that
  suggestion; "Switch" submits Shopify's localization form. The lead
  ("Looks like you're in Sweden.") is only shown when a country we sell to
  was detected, with the place phrase adjusted per language (LEAD_PLACES).

  Where: a bar fixed along the bottom of the window, shown only once
  Shopify's own cookie banner (also at the bottom) is out of the way.

  When it never shows again (on this domain):
  - after "Stay here" (remember_days);
  - after any explicit switch. Switching marks this domain AND, via a
    ?ls_geo=1 marker added to every localization form's return address
    (this strip's and the header selector's), the domain the visitor lands
    on - cookies are per domain, so the marker carries the choice over.

  Also carries an answered cookie choice across our domains
  (?ls_consent=all|essential, same as assets/location-popup.js) while the
  location popup is switched off.

  Wording (1.3.5): all strip text lives here (TEXTS) and is written into the
  section's empty [data-ls-geo-t] slots. It is in the BROWSER's first
  language when that is one of ours (en, de, no), otherwise in the page's
  language - the same language the language picker suggests. When that
  differs from the page language, the country names in the picker are
  rewritten in it too (Intl.DisplayNames, where the browser has it) and
  re-sorted, so the sentence never mixes languages.
*/
(function () {
  var DONE_COOKIE = 'ls_geo_done';
  var GEO_PARAM = 'ls_geo';
  var CONSENT_PARAM = 'ls_consent';
  var FOREVER_DAYS = 365;

  // All wording on the strip, per language. %c in `lead` is replaced by the
  // place phrase ("in Sweden"). Kept ASCII-only on purpose (\u escapes).
  var TEXTS = {
    en: {
      lead: "Looks like you're %c.",
      leadIn: 'in',
      before: 'Show prices for',
      middle: 'in',
      after: '',
      country: 'Country',
      language: 'Language',
      switchLabel: 'Switch',
      stay: 'Stay here',
      region: 'Country and language suggestion'
    },
    de: {
      lead: 'Sieht aus, als w\u00e4ren Sie %c.',
      leadIn: 'in',
      before: 'Preise f\u00fcr',
      middle: 'auf',
      after: 'anzeigen',
      country: 'Land',
      language: 'Sprache',
      switchLabel: 'Wechseln',
      stay: 'Hier bleiben',
      region: 'L\u00e4nder- und Sprachvorschlag'
    },
    no: {
      lead: 'Det ser ut som du er %c.',
      leadIn: 'i',
      before: 'Vis priser for',
      middle: 'p\u00e5',
      after: '',
      country: 'Land',
      language: 'Spr\u00e5k',
      switchLabel: 'Bytt',
      stay: 'Bli her',
      region: 'Forslag om land og spr\u00e5k'
    }
  };

  // Countries whose name needs an article or a different preposition in the
  // lead sentence. Anything not listed uses "<leadIn> <name>".
  var LEAD_PLACES = {
    en: {
      US: 'in the United States',
      GB: 'in the United Kingdom',
      NL: 'in the Netherlands',
      AE: 'in the United Arab Emirates',
      PH: 'in the Philippines',
      MV: 'in the Maldives',
      SB: 'in the Solomon Islands',
      FJ: 'in Fiji',
      BS: 'in the Bahamas',
      FO: 'in the Faroe Islands',
      KY: 'in the Cayman Islands',
      DO: 'in the Dominican Republic',
      CF: 'in the Central African Republic',
      GM: 'in the Gambia',
      HK: 'in Hong Kong',
      MO: 'in Macao'
    },
    de: {
      CH: 'in der Schweiz',
      NL: 'in den Niederlanden',
      US: 'in den USA',
      GB: 'im Vereinigten K\u00f6nigreich',
      SK: 'in der Slowakei',
      TR: 'in der T\u00fcrkei',
      AE: 'in den Vereinigten Arabischen Emiraten',
      PH: 'auf den Philippinen',
      MV: 'auf den Malediven',
      SB: 'auf den Salomonen',
      FJ: 'auf Fidschi',
      WS: 'auf Samoa',
      CY: 'auf Zypern',
      MT: 'auf Malta',
      BS: 'auf den Bahamas',
      FO: 'auf den F\u00e4r\u00f6ern',
      KY: 'auf den Kaimaninseln',
      SC: 'auf den Seychellen',
      MU: 'auf Mauritius',
      JM: 'auf Jamaika',
      CU: 'auf Kuba',
      UA: 'in der Ukraine',
      MN: 'in der Mongolei',
      DO: 'in der Dominikanischen Republik',
      CF: 'in der Zentralafrikanischen Republik',
      LB: 'im Libanon',
      OM: 'im Oman',
      IR: 'im Iran',
      IQ: 'im Irak',
      YE: 'im Jemen',
      SN: 'im Senegal',
      SD: 'im Sudan',
      TD: 'im Tschad',
      NE: 'im Niger',
      XK: 'im Kosovo',
      VA: 'im Vatikanstaat',
      HK: 'in Hongkong',
      MO: 'in Macau'
    },
    no: {
      IS: 'p\u00e5 Island',
      CY: 'p\u00e5 Kypros',
      MT: 'p\u00e5 Malta',
      PH: 'p\u00e5 Filippinene',
      MV: 'p\u00e5 Maldivene',
      FJ: 'p\u00e5 Fiji',
      SB: 'p\u00e5 Salomon\u00f8yene',
      WS: 'p\u00e5 Samoa',
      FO: 'p\u00e5 F\u00e6r\u00f8yene',
      GL: 'p\u00e5 Gr\u00f8nland',
      BS: 'p\u00e5 Bahamas',
      KY: 'p\u00e5 Cayman\u00f8yene',
      SC: 'p\u00e5 Seychellene',
      MU: 'p\u00e5 Mauritius',
      JM: 'p\u00e5 Jamaica',
      CU: 'p\u00e5 Cuba',
      BB: 'p\u00e5 Barbados',
      CV: 'p\u00e5 Kapp Verde',
      MG: 'p\u00e5 Madagaskar',
      LK: 'p\u00e5 Sri Lanka',
      HK: 'i Hongkong',
      MO: 'i Macao'
    }
  };

  // Intl.DisplayNames' long form adds "SAR China" etc. to these; the short
  // form is the everyday name. (Short is NOT used for all: it gives "US"/"UK".)
  var SHORT_NAME_CODES = ['HK', 'MO', 'PS'];

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function inEditor() {
    return document.documentElement.classList.contains('shopify-design-mode');
  }

  // The pickers sit inside a sentence, so each one is sized to the option
  // it shows rather than to the longest country name in the list.
  var measureCanvas = null;
  function sizeSelect(select) {
    if (!select || select.selectedIndex < 0) return;
    try {
      measureCanvas = measureCanvas || document.createElement('canvas');
      var ctx = measureCanvas.getContext('2d');
      var style = window.getComputedStyle(select);
      ctx.font = style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
      var text = select.options[select.selectedIndex].text;
      var extra = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 2;
      select.style.width = Math.ceil(ctx.measureText(text).width + extra) + 'px';
    } catch (e) {
      /* falls back to the browser's own width */
    }
  }

  // Remove our own markers from the address bar (cosmetic).
  function stripParams(names) {
    try {
      var url = new URL(window.location.href);
      var changed = false;
      names.forEach(function (name) {
        if (url.searchParams.has(name)) {
          url.searchParams.delete(name);
          changed = true;
        }
      });
      if (changed) window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* cosmetic only */
    }
  }

  function addParam(path, name, value) {
    try {
      var url = new URL(path || '/', window.location.origin);
      url.searchParams.set(name, value);
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return path;
    }
  }

  function returnInputs() {
    return document.querySelectorAll('form[action*="/localization"] input[name="return_to"]');
  }

  // Any localization form (this strip, header, drawer) is an explicit choice.
  function markLocalizationForms() {
    returnInputs().forEach(function (input) {
      input.value = addParam(input.value || window.location.pathname + window.location.search, GEO_PARAM, '1');
    });
    document.querySelectorAll('form[action*="/localization"]').forEach(function (form) {
      if (form.dataset.lsGeoMarked) return;
      form.dataset.lsGeoMarked = 'true';
      form.addEventListener('submit', function () {
        setCookie(DONE_COOKIE, 'switched', FOREVER_DAYS);
      });
    });
  }

  /* ---------- Cookie consent carry-over ---------- */

  function getCustomerPrivacy() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.setTrackingConsent === 'function' ? cp : null;
  }

  function waitForCustomerPrivacy(callback, timeoutMs) {
    try {
      if (!getCustomerPrivacy() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) {
      /* polling below still picks it up */
    }
    var deadline = Date.now() + (timeoutMs || 4000);
    (function poll() {
      var cp = getCustomerPrivacy();
      if (cp) return callback(cp);
      if (Date.now() >= deadline) return callback(null);
      window.setTimeout(poll, 50);
    })();
  }

  function currentChoice(cp) {
    if (!cp) return null;
    try {
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        var keys = ['analytics', 'marketing', 'preferences'];
        if (keys.every(function (k) { return c[k] === 'yes'; })) return 'all';
        if (keys.every(function (k) { return c[k] === 'no'; })) return 'essential';
        return null;
      }
      if (typeof cp.getTrackingConsent === 'function') {
        var t = cp.getTrackingConsent();
        if (t === 'yes') return 'all';
        if (t === 'no') return 'essential';
      }
    } catch (e) {
      /* nothing to carry */
    }
    return null;
  }

  function unanswered(cp) {
    if (!cp) return false;
    try {
      if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner() !== true) return false;
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        return !c.analytics && !c.marketing && !c.preferences;
      }
      if (typeof cp.getTrackingConsent === 'function') return cp.getTrackingConsent() === 'no_interaction';
    } catch (e) {
      /* treat as answered */
    }
    return false;
  }

  function stampConsent(cp) {
    var choice = currentChoice(cp || getCustomerPrivacy());
    if (!choice) return;
    returnInputs().forEach(function (input) {
      input.value = addParam(input.value || window.location.pathname + window.location.search, CONSENT_PARAM, choice);
    });
  }

  function initConsentCarry(carried) {
    if (inEditor()) return;
    // The location popup does all of this itself when it is on the page.
    if (document.querySelector('modal-dialog[data-location-popup]')) return;
    if (carried) {
      waitForCustomerPrivacy(function (cp) {
        if (!cp || !unanswered(cp)) return;
        var granted = carried === 'all';
        try {
          cp.setTrackingConsent(
            { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
            function () {}
          );
        } catch (e) {
          /* Shopify's own banner will ask instead */
        }
      }, 4000);
    }
    waitForCustomerPrivacy(stampConsent, 6000);
    document.addEventListener('visitorConsentCollected', function () {
      stampConsent();
    });
  }

  /* ---------- Language matching ---------- */

  function baseLang(code) {
    var base = String(code || '').toLowerCase().split(/[-_]/)[0];
    return base === 'nb' || base === 'nn' ? 'no' : base;
  }

  // The page language the browser asks for first, if we offer it.
  function preferredLanguage(languageSelect, current) {
    if (!languageSelect) return null;
    var wanted = (navigator.languages && navigator.languages[0]) || navigator.language;
    if (!wanted || baseLang(wanted) === baseLang(current)) return null;
    var match = Array.prototype.filter.call(languageSelect.options, function (option) {
      return baseLang(option.value) === baseLang(wanted);
    })[0];
    return match || null;
  }

  // The language the strip is WRITTEN in: the browser's first language if we
  // have wording for it, else the page language, else English. Matches the
  // language preferredLanguage() suggests, so text and suggestion agree.
  function textLanguage(pageLanguage) {
    var wanted = baseLang((navigator.languages && navigator.languages[0]) || navigator.language);
    if (TEXTS[wanted]) return wanted;
    var page = baseLang(pageLanguage);
    return TEXTS[page] ? page : 'en';
  }

  function applyTexts(strip, lang) {
    var t = TEXTS[lang] || TEXTS.en;
    strip.setAttribute('lang', lang === 'no' ? 'nb' : lang);
    strip.setAttribute('aria-label', t.region);
    strip.querySelectorAll('[data-ls-geo-t]').forEach(function (el) {
      var key = el.getAttribute('data-ls-geo-t');
      if (key === 'switch') key = 'switchLabel';
      var text = t[key] || '';
      // "after" sits right behind the language picker with no space of its
      // own in the markup (German: "... auf [Deutsch] anzeigen").
      el.textContent = key === 'after' && text ? ' ' + text : text;
    });
  }

  // Rewrite the country picker in the strip's language, keeping
  // "Name (CUR)" and the selection; re-sort so the list stays alphabetical.
  function relabelCountries(countrySelect, lang) {
    if (!countrySelect || typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return;
    var locale = lang === 'no' ? 'nb' : lang;
    var longNames, shortNames, collator;
    try {
      longNames = new Intl.DisplayNames([locale], { type: 'region' });
      shortNames = new Intl.DisplayNames([locale], { type: 'region', style: 'short' });
      collator = new Intl.Collator(locale);
    } catch (e) {
      return;
    }
    var selected = countrySelect.value;
    var options = Array.prototype.slice.call(countrySelect.options);
    options.forEach(function (option) {
      var code = option.value;
      var name = null;
      try {
        name = (SHORT_NAME_CODES.indexOf(code) !== -1 ? shortNames : longNames).of(code);
      } catch (e) {
        name = null;
      }
      // DisplayNames echoes the code back when it has no name for it.
      if (!name || name === code) return;
      option.dataset.name = name;
      option.textContent = name + ' (' + option.dataset.currency + ')';
    });
    options
      .sort(function (a, b) {
        return collator.compare(a.dataset.name || a.text, b.dataset.name || b.text);
      })
      .forEach(function (option) {
        countrySelect.appendChild(option);
      });
    countrySelect.value = selected;
  }

  /* ---------- The strip ---------- */

  function isStaffPreview() {
    if (/(?:^|[?&])show_banner=1(?:&|$)/.test(window.location.search)) return false;
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    return !!(role && role !== 'main');
  }

  // Shopify's own cookie banner also sits at the bottom of the window. Wait
  // until it is gone (answered, or never shown) so the two never stack.
  function cookieBannerVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return banner.getBoundingClientRect().height > 0;
  }

  function whenCookieBannerClear(callback) {
    var done = false;
    var deadline = Date.now() + 10 * 60 * 1000;
    function finish() {
      if (done) return;
      done = true;
      callback();
    }
    document.addEventListener('visitorConsentCollected', function () {
      window.setTimeout(function () {
        if (!cookieBannerVisible()) finish();
      }, 400);
    });
    // Give Shopify's banner a moment to appear before deciding it is absent.
    window.setTimeout(function poll() {
      if (done) return;
      if (!cookieBannerVisible()) return finish();
      if (Date.now() < deadline) window.setTimeout(poll, 700);
    }, 1500);
  }

  // Keep the end of the page reachable while the bar is up.
  function reserveSpace(strip) {
    document.body.style.paddingBottom = strip.hidden ? '' : strip.offsetHeight + 'px';
  }

  function bind(strip, arrivedBySwitch) {
    if (!strip || strip.dataset.lsGeoBound) return;
    strip.dataset.lsGeoBound = 'true';

    var current = strip.dataset.current;
    var currentCurrency = strip.dataset.currentCurrency;
    var currentLanguage = strip.dataset.currentLanguage;
    var rememberDays = parseInt(strip.dataset.remember, 10) || FOREVER_DAYS;
    var countrySelect = strip.querySelector('[data-ls-geo-country]');
    var languageSelect = strip.querySelector('[data-ls-geo-language]');
    var lead = strip.querySelector('[data-ls-geo-lead]');

    // Write the strip in the visitor's language (see textLanguage). Country
    // names are only rewritten when that is not the page's own language -
    // otherwise Shopify's names are already right.
    var lang = textLanguage(currentLanguage);
    applyTexts(strip, lang);
    if (lang !== baseLang(currentLanguage)) relabelCountries(countrySelect, lang);

    // The selected country's flag in front of the country picker (a
    // <select> cannot show images in its list, so only the chosen one).
    var flag = strip.querySelector('[data-ls-geo-flag]');
    function updateFlag() {
      if (!flag || countrySelect.selectedIndex < 0) return;
      var src = countrySelect.options[countrySelect.selectedIndex].dataset.flag;
      if (src) {
        flag.src = src;
        flag.removeAttribute('srcset');
        flag.loading = 'eager';
      }
    }

    [countrySelect, languageSelect].forEach(function (select) {
      if (select) select.addEventListener('change', function () {
        if (select === countrySelect) updateFlag();
        sizeSelect(select);
        reserveSpace(strip);
      });
    });

    // "Looks like you're in <country>." - only for a detected country we sell to.
    function setLead(code) {
      if (!lead) return;
      var option = code ? countrySelect.querySelector('option[value="' + code + '"]') : null;
      var t = TEXTS[lang] || TEXTS.en;
      var template = t.lead || '';
      if (!option || template.indexOf('%c') === -1) {
        lead.textContent = '';
        lead.hidden = true;
        return;
      }
      var places = LEAD_PLACES[lang] || {};
      var place = places[code] || (t.leadIn || 'in') + ' ' + (option.dataset.name || option.text);
      lead.textContent = template.replace('%c', place);
      lead.hidden = false;
    }

    strip.querySelectorAll('[data-ls-geo-stay]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!inEditor()) setCookie(DONE_COOKIE, 'stay', rememberDays);
        strip.hidden = true;
        reserveSpace(strip);
      });
    });

    function suggest(countryCode) {
      var countryOption = countryCode ? countrySelect.querySelector('option[value="' + countryCode + '"]') : null;
      var languageOption = preferredLanguage(languageSelect, currentLanguage);
      if (!countryOption && !languageOption) return false;
      if (countryOption) countrySelect.value = countryCode;
      if (languageOption) languageSelect.value = languageOption.value;
      function reveal() {
        updateFlag();
        strip.hidden = false;
        sizeSelect(countrySelect);
        sizeSelect(languageSelect);
        reserveSpace(strip);
      }
      if (inEditor()) {
        reveal();
      } else {
        whenCookieBannerClear(reveal);
      }
      return true;
    }

    window.addEventListener('resize', function () {
      if (!strip.hidden) reserveSpace(strip);
    });

    if (inEditor()) {
      // Preview with the first country we sell to in another currency.
      var sample = Array.prototype.filter.call(countrySelect.options, function (option) {
        return option.dataset.currency !== currentCurrency;
      })[0];
      strip._lsSample = sample ? sample.value : null;
      strip._lsSuggest = function (code) {
        setLead(code);
        return suggest(code);
      };
      if (strip.dataset.editorSelected === 'true' && sample) strip._lsSuggest(sample.value);
      return;
    }

    if (arrivedBySwitch || getCookie(DONE_COOKIE) || isStaffPreview()) return;
    if (!window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) return;

    fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var code =
          data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        code = code ? String(code).toUpperCase() : null;
        var option = code ? countrySelect.querySelector('option[value="' + code + '"]') : null;
        var countryMismatch = !!(option && code !== current && option.dataset.currency !== currentCurrency);
        setLead(option ? code : null);
        suggest(countryMismatch ? code : null);
      })
      .catch(function () {
        setLead(null);
        suggest(null);
      });
  }

  var arrivedBySwitch = false;
  var carriedConsent = null;

  function init() {
    if (!inEditor()) {
      var search = window.location.search;
      arrivedBySwitch = /(?:^|[?&])ls_geo=1(?:&|$)/.test(search);
      var consentMatch = search.match(/(?:^|[?&])ls_consent=(all|essential)(?:&|$)/);
      carriedConsent = consentMatch ? consentMatch[1] : null;
      if (arrivedBySwitch) setCookie(DONE_COOKIE, 'switched', FOREVER_DAYS);
      stripParams([GEO_PARAM].concat(document.querySelector('modal-dialog[data-location-popup]') ? [] : [CONSENT_PARAM]));
      markLocalizationForms();
      initConsentCarry(carriedConsent);
    }
    refresh();
  }

  function refresh() {
    var strips = document.querySelectorAll('[data-ls-geo]');
    if (!strips.length) return;
    bind(strips[strips.length - 1], arrivedBySwitch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', refresh);

  document.addEventListener('shopify:section:select', function (event) {
    var strip = document.querySelector('[data-ls-geo]');
    if (!strip || event.detail.sectionId !== strip.dataset.sectionId) return;
    strip.dataset.editorSelected = 'true';
    if (strip._lsSuggest && strip._lsSample) strip._lsSuggest(strip._lsSample);
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var strip = document.querySelector('[data-ls-geo]');
    if (!strip || event.detail.sectionId !== strip.dataset.sectionId) return;
    strip.dataset.editorSelected = 'false';
    strip.hidden = true;
    document.body.style.paddingBottom = '';
  });
})();
